import React from 'react';
import Styles from './styles';

const { Container, Title, Subtitle, Contents } = Styles;

export const NoFolderItems: React.FC = () => {
  return (
    <Container>
      <Contents>
        <Title>Nothing added to library</Title>
        <Subtitle>Smash the ⭐ next to any Smart Clip™️ to save it in your library.</Subtitle>
      </Contents>
    </Container>
  );
};
